export default __webpack_public_path__ + "static/media/face6.164f9103.jpg";